import { useTheme } from "@mui/styles";
import React from "react";
import { BCPBadgeCheck } from "./bcp/BCPIcons";

export default function VerifiedIcon(props) {
  const theme = useTheme();

  return (
    <BCPBadgeCheck style={{ color: theme.palette.success.main }} {...props} />
  );
}
